import React from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import FieldGroup from '../field_group/FieldGroup';
import Form from '../form/Form';
import { requiredValidator } from '../field_group/validators';
import { getErrorValue } from '../../utils/utility';
import { listHeatPumpType } from '../../redux/references/hot_water_system_actions';

export class HeatPumpDetail extends React.Component {
  constructor(props) {
    super(props);
    this.formRef = undefined;
  }

  getHeatPumpData() {
    return this.formRef.getFormData();
  }

  componentDidMount() {
    if (this.props.listHeatPumpType) {
      this.props.listHeatPumpType();
    }
  }

  renderOption(item) {
    return (
      <option key={item.id} value={item.id}>
        {item.name}
      </option>
    );
  }

  render() {
    const {
      name,
      type_id,
      COP,
      description,
      image,
    } = this.props.heatPump;
    const { disabled, fieldErrors, t, ...otherAttr } = this.props;
    const customAttr = { disabled };
    return (
      <Form
        image={image}
        {...otherAttr}
        ref={ref => this.formRef = ref}
        errorMessage={getErrorValue(fieldErrors, 'detail')}
      >
        <FieldGroup
          id="hot-water-heat-pump-name"
          field="name"
          type="text"
          label={t('name')}
          placeholder={t('heat pump name')}
          value={name}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'name')}
          {...customAttr}
        />
        <FieldGroup
          id="hot-water-heat-pump-type"
          field="type_id"
          componentClass="select"
          label={t('type')}
          value={type_id}
          defaultDirty={true}
          errorMessage={getErrorValue(fieldErrors, 'type_id')}
          {...customAttr}
        >
          {this.props.heatPumpTypeList.map(type => this.renderOption(type))}
        </FieldGroup>
        <FieldGroup
          id="hot-water-heat-pump-COP"
          field="COP"
          type="number"
          label={<span>{t('COP')}</span>}
          placeholder="4"
          value={COP}
          validators={[requiredValidator]}
          errorMessage={getErrorValue(fieldErrors, 'COP')}
          {...customAttr}
        />
        <FieldGroup
          id="hot-water-heat-pump-description"
          field="description"
          componentClass="textarea"
          label={t('description')}
          value={description}
          {...customAttr}
        />
      </Form>
    );
  }
}

HeatPumpDetail.defaultProps = {
  heatPump: {},
};

const mapStateToProps = state => ({
  heatPumpTypeList: state.reference.hotWaterSystem.heatPumpTypeList,
});

const mapDispatchToProps = dispatch => ({
  listHeatPumpType: () => dispatch(listHeatPumpType()),
});

export default translate('translations', { withRef: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { withRef: true },
  )(HeatPumpDetail)
);



// WEBPACK FOOTER //
// ./src/components/hot_water_system/HeatPumpDetail.js